import styled, { css } from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const OperatorImage = styled.div`
  width: 90px;
  background-color: ${ColorSF2.paleBlue};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
  font-size: 12px;
  @media (max-height: 530px) {
    display: none;
  }
`;
export const OperatorBox = styled.div`
  min-width: 180px;
  border-right: 4px solid ${ColorSF2.white};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  @media (max-height: 530px) {
    min-width: 100px;
  }
`;
export const Table = styled.div`
  width: 100%;
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  height: calc(100% - 278px);
  @media (max-height: 530px) {
    height: auto;
  }
`;
export const List = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  margin: 9px;
  background-color: ${ColorSF2.whisperGray};
  box-shadow: 0px 1px 6px ${ColorSF2.transparentShadow};
  height: 210px;
`;
export const Tbody = styled.div`
  flex: 1 1 100%;
  overflow-y: scroll;
  height: 100%;
  background-color: ${ColorSF2.white};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  @media (max-height: 530px) {
    overflow-y: unset;
  }
`;

export const Operator = styled.div`
  display: flex;
  flex-direction: row;
`;
export const Thumbnail = styled(Operator)`
  width: 220px;
  height: 270px;
  display: flex;
  justify-content: center;
  background-color: ${ColorSF2.whisperGray}; // 画像の背景
`;
export const ImageWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Operator01 = styled(Operator)`
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
`;

export const MediaIconP = styled.img`
  height: 150px;
  cursor: pointer;
`;
export const MediaIconL = styled.img`
  width: 200px;
  cursor: pointer;
`;

export const style = {
  main: {
    width: '100%',
    height: '100%',
    flex: '1 1 0%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  contents: {
    height: '100%',
    flex: '1 1 0%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  time: {
    textAlign: 'center',
  },
  underAnalysis: {
    height: 60,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  analyzedContent: {
    width: 200,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    textAlign: 'center',
  },
  nodata: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
  },
  loading: {
    width: 60,
    height: 60,
  },
  loadingBox: {
    width: 60,
    height: 60,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  description: {
    margin: 10,
  },
  operatorInfoBox: {
    display: 'flex',
  },
  operatorName: {
    width: '100%',
    backgroundColor: ColorSF2.paleBlue,
    fontSize: 12,
    fontWeight: 'bold',
    padding: 9,
    display: 'flex',
    alignItems: 'center',
    wordBreak: 'break-all',
  },
};

export const OperatorInfo = styled.div`
  width: 100%;
  height: 175px;
  display: flex;
  background-color: ${ColorSF2.paleBlue};
  @media (max-height: 530px) {
    height: 110px;
  }
`;
export const MapBox = styled.div`
  flex: 0 0 170px;
  display: flex;
  border-left: 4px solid ${ColorSF2.white};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
export const TitleBar = styled.div`
  width: 100%;
  height: 50px;
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: ${ColorSF2.paleBlue};
  font-weight: bold;
  padding: 0px 15px;
  @media (max-height: 530px) {
    height: 30px;
    font-size: 12px;
    padding: 0px 0px 0px 15px;
  }
`;
export const TitleBarText = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;
export const ToolButton = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;
export const ToolIcon = styled.img`
  margin: 0px 1px;
  background-color: ${props =>
    props.selected ? ColorSF2.skyBlue : ColorSF2.paleBlue};
  width: 30px;
  height: 30x;
  cursor: ${props =>
    props.selected || !props.selectable ? 'default' : 'pointer'};
  ${props =>
    !props.selected &&
    props.selectable &&
    css`
      &:hover {
        background: ${ColorSF2.skyBlue};
      }
    `}
  @media (max-height: 530px) {
    width: 24px;
    height: 24px;
    margin: 0px 8px;
  }
`;
export const ListsWrapper = styled.div`
  height: calc(100% - 92px);
`;
export const PlayCircleStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 50,
  height: 50,
  zIndex: 900,
};
